<div>
    <h4>No plan loaded</h4>
    <p>Upload an assortment plan or open a saved plan from the Repository</p>
    <div class="buttons-container">
        <button
            class="mdc-button mdc-button--raised mat-mdc-raised-button mat-accent mat-mdc-button-base"
            (click)="params.openUploadPlanModal()"
        >
            Upload Assortment Plan
        </button>
        <button
            class="mdc-button mdc-button--raised mat-mdc-raised-button mat-accent mat-mdc-button-base"
            (click)="params.openRepositoryModal()"
        >
            Open Repository
        </button>
    </div>
</div>
